import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { FormLabel } from 'pages/settings_page/style';
import { useDispatch, useSelector } from 'react-redux';
import { bulkAttributeUpdate, getAttributes, setSelectedItems } from 'redux/slices/userSlice';
import { ContentWrap } from 'component/setup_component/ad_sql/style';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';

const BulkUpdateUser = ({ setBulkUpdateModal }) => {
  const dispatch = useDispatch();
  const refreshUserTab = useRefreshUserTab();
  const [loading, setLoading] = useState(false);
  const { selectedItems, userAttributes } = useSelector((state) => state.getUsers);
  const selectedNode = useSelector((state) => state.selectedNode);
  const attributes = [
    'displayName',
    'givenName',
    'surname',
    'initials',
    'emailAddress',
    'street',
    'poBox',
    'city',
    'state',
    'zip',
    'country',
    'jobTitle',
    'company',
    'department',
    'description',
    'telephoneNumber',
    'office',
    'webPage',
  ];

  // Merge `attributes` and `userAttributes`
  const mergedAttributes = Array.isArray(userAttributes) ? [...attributes, ...userAttributes] : [...attributes];

  useEffect(() => {
    dispatch(getAttributes(selectedNode.currentdomainId));
  }, [selectedNode.currentdomainId]);

  const onFinish = async (value) => {
    value.users = selectedItems;
    value.fqdn = selectedNode.domainName;
    try {
      setLoading(true);
      const response = await dispatch(bulkAttributeUpdate(value));
      if (response?.payload.status === 200) {
        await SweetSweetAlert({
          sweetData: `Attributes Updated Successfully for the selected ${
            selectedItems.length === 1 ? 'user' : 'users'
          }.`,
          icon: 'success',
          buttonColor: 'green',
        });
      } else if (response?.payload.status === 400) {
        await SweetSweetAlert({ text: response.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
      dispatch(setSelectedItems([]));
      setBulkUpdateModal(false);
      await refreshUserTab();
    }
  };

  return (
    <>
      {loading && <ModalOpenLoader />}
      <h2 className='af-bulk-updateuser-header'>Update Attribute</h2>
      <ContentWrap className='af-bulk-updateuser-wrap'>
        <Form
          size='large'
          name='bulkupdate'
          layout='vertical'
          onFinish={onFinish}
          className='af-bulk-updateuser-form-element'
          style={{ width: '90%' }}
        >
          <FormLabel
            className='formItemContentWidth af-bulk-updateuser-form-item-attribute'
            label='Name'
            name='attributeName'
          >
            <Select
              placeholder='Select Attribute'
              allowClear
              showSearch
              className='af-bulk-updateuser-selectorbox-attribute'
            >
              {mergedAttributes.length &&
                mergedAttributes.map((item) => (
                  <Select.Option key={item} value={item} className='af-bulk-updateuser-selectorbox-attribute-option'>
                    {item}
                  </Select.Option>
                ))}
            </Select>
          </FormLabel>
          <FormLabel
            className='formItemContentWidth af-bulk-updateuser-form-item-value'
            label='Value'
            name='attributeValue'
          >
            <Input className='af-bulk-updateuser-input-value' />
          </FormLabel>
          <FormLabel style={{ textAlign: 'center', marginBottom: 0 }} className='af-bulk-updateuser-form-item-button'>
            <StyledButton type='primary' htmlType='submit' className='af-bulk-updateuser-submit-button'>
              Update
            </StyledButton>
          </FormLabel>
        </Form>
      </ContentWrap>
    </>
  );
};

export default BulkUpdateUser;
